/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CardRegistrationStartSchema } from '../models/CardRegistrationStartSchema';
import type { ConfirmCardSchema } from '../models/ConfirmCardSchema';
import type { PaymentMethodResponse } from '../models/PaymentMethodResponse';
import type { SetPaymentMethodSchema } from '../models/SetPaymentMethodSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionPaymentMethodApi {
    /**
     * Get Subscription Payment Method
     * Get the company's subscription payment method. Required Permission: list_my_company_orders
     * @returns PaymentMethodResponse OK
     * @throws ApiError
     */
    public static subscriptionPaymentMethodGetSubscriptionPaymentMethodGet(): CancelablePromise<PaymentMethodResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/subscription-payment-method/',
        });
    }
    /**
     * Set Subscription Payment Method
     * Set the company's subscription payment method. Required Permission: pay_order
     * @returns PaymentMethodResponse OK
     * @throws ApiError
     */
    public static subscriptionPaymentMethodSetSubscriptionPaymentMethodPut({
        requestBody,
    }: {
        requestBody: SetPaymentMethodSchema,
    }): CancelablePromise<PaymentMethodResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/subscription-payment-method/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Register Subscription Card
     * Start card registration (COF) via the payment gateway. Required Permission: pay_order
     * @returns CardRegistrationStartSchema OK
     * @throws ApiError
     */
    public static subscriptionPaymentMethodRegisterSubscriptionCardPost({
        returnPath,
    }: {
        returnPath?: (string | null),
    }): CancelablePromise<CardRegistrationStartSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/subscription-payment-method/card/register',
            query: {
                'return_path': returnPath,
            },
        });
    }
    /**
     * Confirm Subscription Card
     * Finalize in-app card registration. Required Permission: pay_order
     * @returns PaymentMethodResponse OK
     * @throws ApiError
     */
    public static subscriptionPaymentMethodConfirmSubscriptionCardPost({
        requestBody,
    }: {
        requestBody: ConfirmCardSchema,
    }): CancelablePromise<PaymentMethodResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/subscription-payment-method/card/confirm',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove Subscription Card
     * Remove the company's stored card. Required Permission: pay_order
     * @returns void
     * @throws ApiError
     */
    public static subscriptionPaymentMethodRemoveSubscriptionCardDelete(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/subscription-payment-method/card',
        });
    }
}
